import { render, staticRenderFns } from "./DeleteClientModal.vue?vue&type=template&id=2ff8867d"
import script from "./DeleteClientModal.vue?vue&type=script&lang=js"
export * from "./DeleteClientModal.vue?vue&type=script&lang=js"
import style0 from "./DeleteClientModal.vue?vue&type=style&index=0&id=2ff8867d&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dusanvelickovic/Herd/bookybook/bookybook-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ff8867d')) {
      api.createRecord('2ff8867d', component.options)
    } else {
      api.reload('2ff8867d', component.options)
    }
    module.hot.accept("./DeleteClientModal.vue?vue&type=template&id=2ff8867d", function () {
      api.rerender('2ff8867d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/layout/extras/modal/DeleteClientModal.vue"
export default component.exports